"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var IconFolders = function IconFolders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M65.0588 40.1942H47.7412L44.2965 36.1214C44.1806 35.9829 44.007 35.9051 43.8259 35.9108H29.8541C27.721 35.9262 26 37.6508 26 39.7729V64.8227C26.0026 66.952 27.7372 68.6776 29.8777 68.6801H65.0588C67.1993 68.6776 68.9339 66.952 68.9365 64.8227V44.0516C68.9339 41.9223 67.1993 40.1968 65.0588 40.1942Z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1459 35.2039H52.8235L49.3788 31.1311C49.263 30.9925 49.0893 30.9148 48.9083 30.9205H34.9412C33.0057 30.9236 31.369 32.346 31.1059 34.2536H43.8447C44.5127 34.2519 45.147 34.5452 45.5765 35.0541L48.5177 38.5323H65.0588C68.1182 38.5375 70.5972 41.0035 70.6024 44.0469V63.6524C72.5421 63.4116 73.9985 61.7724 74 59.8277V39.0566C73.9949 36.9382 72.2753 35.2193 70.1459 35.2039Z",
    fill: props.color
  }));
};

IconFolders.id = "folders";
IconFolders.code = "IconFolders";
IconFolders.defaultProps = {
  color: "currentColor"
};
var _default = IconFolders;
exports["default"] = _default;